import Button from '@components/std-components/Button'
import PopupComponent from '@components/std-components/Popup'
import Typography from '@components/std-components/Typography'
import TextareaAutosize from '@material-ui/core/TextareaAutosize'
import EnCross from '@meronex/icons/en/EnCross'
import React, { useRef, useState } from 'react'
import * as css from './InputEditorPopup.css'

export interface InputEditorPopupProps {
  onCancelClick?: any
  onSaveClick?: any
  onClose?: any
  value: string
  placeholder: string
  header: string
  saveLabel?: string
}

const InputEditorPopup: React.FunctionComponent<InputEditorPopupProps> = ({
  onCancelClick,
  onSaveClick,
  onClose,
  value,
  placeholder,
  header,
  saveLabel
}) => {
  const [inputValue, setInputValue] = useState(value)
  const ref = useRef<any>()
  return (
    <PopupComponent onClose={onClose} open={true} ref={ref}>
      <div className='flex column'>
        <div className='flex justify-space-between'>
          <div>
            <Typography variant='h1'> {header}</Typography>
          </div>
          <div className={css.crossIcon} onClick={() => onCancelClick()}>
            <EnCross size={24} />
          </div>
        </div>
        <div>
          <TextareaAutosize
            rows={6}
            className={css['textarea']}
            aria-label={placeholder}
            value={inputValue}
            placeholder={placeholder}
            maxLength={250}
            rowsMax={4}
            onChange={e => {
              setInputValue(e.target.value)
            }}
          />
        </div>
        <div>
          <div className='flex justify-end'>
            <Button
              disabled={inputValue === value}
              variant='primary'
              theme='custom'
              type='button'
              size='normal'
              onClick={() => onSaveClick(inputValue)}
            >
              <Typography variant='custom'>{saveLabel}</Typography>
            </Button>
          </div>
        </div>
      </div>
    </PopupComponent>
  )
}

export default InputEditorPopup
